export const gitInfo = { commitHash: "6dc90c1", version: "6dc90c1" };
